export default "__VITE_ASSET__5ef6cf31__"